import { render, staticRenderFns } from "./RelatedProducts.vue?vue&type=template&id=0a547685&scoped=true"
import script from "./RelatedProducts.vue?vue&type=script&lang=js"
export * from "./RelatedProducts.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./RelatedProducts.vue?vue&type=style&index=0&id=0a547685&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./RelatedProducts.vue?vue&type=style&index=1&id=0a547685&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0a547685",
  "5e31e68e"
  
)

export default component.exports